<template>
  <div class="wrapper">
    <div class="header">
      <div class="buttons">
        <router-link to="/cart" class="back">
          <vk-icon icon="triangle-left" ratio="2"></vk-icon>
        </router-link>
        <span>決済URL発行受付</span>
      </div>
    </div>
    <div class="content">
      <p>ご注文受け付けました。</p>
      <p class="text-center text-bold">{{ $store.state.order.email }}</p>
      <p>上記のアドレスに『注文受付通知』をお送りいたしますので、内容をご確認ください。</p>
      <p>注文受付通知のメールが届かない場合は、info@harigu.comまでご連絡願います。</p>
      <p>決済商品の出品準備ができ次第『harigushop@yahoo.co.jp』よりURLをご連絡させて頂きますので、お待ち願います。</p>
      <div class="mt-4 center-block">
        <button class="btn btn-secondary w-50" @click="$router.push('/')">TOPページへ</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'PaymentDone',
    data () {
      return {
        email: '',
      };
    },
    created () {
      if (this.cart.length) {
        this.initialize();
      }
    },
    computed: {
      cart () {
        return this.$store.state.cart;
      }
    },
    methods: {
      async initialize () {
      },
    }
  };
</script>

<style scoped lang="scss">
  .content {
    padding: 1rem;
  }
  .header {
    position: sticky;
    position: -webkit-sticky;
    top: 48px;
    z-index:999;
  }
  .buttons {
    background-color: rgb(128, 127, 128);
    color: #fff;
    font-weight: bold;
    overflow: hidden;
    .back {
      color: rgb(240, 240, 240) !important;
      float: left;
      display: block;
    }
    span {
      float: right;
      display: block;
      padding-right: 10px;
      line-height: 40px;
    }
  }
  .center-block {
    text-align: center;
  }
</style>
